import { OrganizationHoldingRepository } from "@domain/organization-holding/repositories/organization-holding.repository";
import { OrganizationHoldingRepositoryService } from "../repositories/organization-holding.service";

export const OrganizationHoldingProvider = [
  {
    provide: OrganizationHoldingRepository,
    useClass: OrganizationHoldingRepositoryService,
  },
];
